import React, { useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";
import SignInWithMSAzure from "../../images/SignInWithMSAzureShort.png";
import Cookie from "js-cookie";
import "./AuthenticatorComponent.css";

// ------------------------------------------------------------------------
const AzureAuthenticatorComponent = (props) => {
  const [user, setUser] = useState(null);
  const msalConfig = {
    auth: {
      clientId: "c5aea2c4-38db-4336-abb1-9d9262402dcd",
      authority: "https://login.microsoftonline.com/common",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
  const msalInstance = new PublicClientApplication(msalConfig);
  // ------------------------------------------------------------------------
  // Fetch user data on authentication
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("msazurelogin");
    if (isLoggedIn === "true") {
      if (!user) {
        if (checkPopupEnabledSilent() === true) {
          fetchUserProfile();
        } else {
          window.alert(
            "Your browser is blocking popups. Please enable them to log in with Google."
          );
        }
      }
    }
  }, []);

  // ------------------------------------------------------------------------
  const fetchUserProfile = async () => {
    await msalInstance.initialize();
    const msalAccount = msalInstance.getAllAccounts();
    let user = null;
    let silentRequest = {
      scopes: ["api://c5aea2c4-38db-4336-abb1-9d9262402dcd/.default"],
      account: null,
    };
    if (msalAccount.length > 0) {
      user = msalAccount[0];
      localStorage.setItem("msal.account", msalAccount);
    } else {
      const storedAccount = localStorage.getItem("msal.account");
      if (storedAccount) {
        user = JSON.parse(storedAccount);
      }
    }
    setUser(user);
    silentRequest.account = user;
    try {
      const tokenResponse = await msalInstance.acquireTokenSilent(
        silentRequest
      );
      props.setShowSignInPage(false);
      props.passBack(tokenResponse.accessToken, tokenResponse.idToken);
    } catch (err) {
      if (err) {
        console.log(err);
        const loginResponse = await msalInstance
          .loginPopup(silentRequest)
          .catch((error) => {
            console.log(error);
          });
        setUser(loginResponse.account);
        localStorage.setItem("msal.account", loginResponse.account);
        localStorage.setItem("msazurelogin", true);
        props.setShowSignInPage(false);
        props.passBack(loginResponse.accessToken, loginResponse.idToken);
      } else {
        msAzureHandleSignOut();
        props.setShowSignInPage(true);
      }
    }
  };

  // ------------------------------------------------------------------------
  const checkPopupEnabledSilent = () => {
    const popup = window.open("", "", "width=1,height=1,left=-9999,top=-9999");

    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      return false;
    }

    popup.close();
    return true;
  };

  const handleLoginClick = () => {
    if (checkPopupEnabledSilent() === true) {
      handleSignIn();
    } else {
      window.alert(
        "Your browser is blocking popups. Please enable them to log in with Google."
      );
    }
  };
  // ------------------------------------------------------------------------
  const handleSignIn = async () => {
    await msalInstance.initialize();
    var loginRequest = {
      scopes: ["api://c5aea2c4-38db-4336-abb1-9d9262402dcd/.default"],
      prompt: "select_account",
    };

    try {
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      setUser(loginResponse.account);
      localStorage.setItem("msal.account", loginResponse.account);
      localStorage.setItem("msazurelogin", true);
      props.setShowSignInPage(false);
      props.passBack(loginResponse.accessToken, loginResponse.idToken);
    } catch (err) {
      console.log(err);
      if (err instanceof Error) {
        if (
          err.name === "BrowserAuthError" &&
          err.message.includes("popup_window_error")
        ) {
          window.alert(
            "Your browser is blocking popups. Please enable them to log in with Microsoft."
          );
        }
      }
    }
  };

  // ------------------------------------------------------------------------
  const msAzureHandleSignOut = async () => {
    await msalInstance.initialize();
    const msalAccount = msalInstance.getAllAccounts();
    let user = null;
    if (msalAccount.length > 0) {
      user = msalAccount[0];
    } else {
      const storedAccount = localStorage.getItem("msal.account");
      if (storedAccount) {
        user = JSON.parse(storedAccount);
      }
    }
    try {
      await msalInstance.logoutPopup({ account: user });
      setUser(null);
      localStorage.removeItem("msal.account");
      localStorage.removeItem("msazurelogin");
      Cookie.remove("agreedToPolicies");
      Cookie.remove("ageVerified");
      props.setShowSignInPage(true);
    } catch (err) {
      console.log(err);
    }
  };
  window.msAzureSignOut = msAzureHandleSignOut;

  // ------------------------------------------------------------------------
  return (
    <div className="msazure" onClick={handleLoginClick}>
      <img
        title="Sign in with Microsoft"
        src={SignInWithMSAzure}
        alt="Sign In with Microsoft"
      ></img>
    </div>
  );
};

// ------------------------------------------------------------------------
export default AzureAuthenticatorComponent;
